// in this js file we have things that we might change later

export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '26a5000d-a599-48d5-97b2-af39a86d6162';
export const MODAL_CLOSE_SEC = 2.5;
